<template>
    <div class="container">
        <div class="background">
            <div class="left"></div>
            <div class="right"></div>
        </div>
        <div class="auth">
            <form class="left" @submit.prevent="auth">
                <div class="logo">Логотип</div>
                <div class="head">Вход в личный кабинет</div>

                <input v-if="smsSent" v-model="smsCode" type="text">
                <input v-else v-model="phoneNumber" type="text">

                <div class="desc">
                    {{ smsSent ? "Введите код из СМС" : "Введите номер телефона для входа в аккаунт" }}
                </div>

                <div v-if="smsSent" class="agreement">
                    <input type="checkbox" v-model="agreementAccept">
                    <div class="text">Я согласен(-на) с Условиями использования
                        и Политикой конфиденциальности</div>
                </div>

                <button v-if="smsSent">Войти</button>
                <button v-else>Получить код</button>

                <div v-if="smsSent" @click="smsSent=false" class="back">
                    <img src="@/assets/img/left_arrow.svg" alt="">
                    <div class="text">Назад</div>
                </div>
            </form>
            <div class="right">
                <img src="@/assets/img/camera.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            smsSent: false,
            agreementAccept: false,
            phoneNumber: "+7 ",
            smsCode: ""
        }
    },
    methods: {
        async auth() {
            if (this.smsSent) {
                if (!this.agreementAccept) {
                    return
                }

                let res = await this.$store.dispatch("request", {
                    method: "PUT",
                    path: "/auth",
                    sendData: {
                        phone: this.phoneNumber.replaceAll(" ", ""),
                        sms_code: this.smsCode
                    }
                })

                if (res.status == 200) {
                    localStorage.setItem("token", res.response.data.access_token)
                    localStorage.setItem("refresh_token", res.response.data.refresh_token)
                    await this.$router.push("/")
                }
            } else {
                let res = await this.$store.dispatch("request", {
                    method: "POST",
                    path: "/auth",
                    sendData: {phone: this.phoneNumber.replaceAll(" ", "")}
                })
                if (res.status == 200) {
                    this.smsSent = true
                }
            }
        }
    },
    watch: {
        phoneNumber() {
            this.phoneNumber = "+7 " + this.phoneNumber.substring(3)
        }
    }
}
</script>


<style lang="scss" scoped>
.container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    .background {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        z-index: -1;
        .left {
            height: 100%;
            width: 50%;
            background: #FFFFFF;
        }
        .right {
            height: 100%;
            width: 50%;
            background: #F2F2F2;
        }
    }
    .auth {
        width: 1100px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
            .head {
                font-weight: 700;
                font-size: 30px;
                line-height: 41px;
                margin-bottom: 32px;
            }
            input[type="text"] {
                width: 352px;
                margin-bottom: 16px;
            }
            .desc {
                font-size: 16px;
                line-height: 20px;
                color: #999999;
            }
            .agreement {
                display: flex;
                align-items: center;
                width: 352px;
                margin-top: 28px;
                .text {
                    width: 287px;
                    margin-left: 12px;
                    font-size: 12px;
                    line-height: 18px;
                }
            }
            button {
                width: 352px;
                margin-top: 40px;
            }
            .back {
                display: flex;
                width: 352px;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                margin-top: 33px;
                .text {
                    font-size: 16px;
                    line-height: 20px;
                    color: #333333;
                    margin-left: 16px;
                    font-weight: 700;
                }
            }
        }
    }
}
</style>
